import script from "./FeedbackLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackLoading.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackLoading.vue?vue&type=style&index=0&id=7537e79b&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7537e79b"]])

export default __exports__